import { lazyLoad } from 'components/ui/LazyLoad'

// RouteType
export const authRoutes = {
  path: '/auth',
  component: lazyLoad(() => import('views/Auth')),

  views: {
    login: {
      path: '/auth/login',
      exact: true,
      component: lazyLoad(() => import('views/Auth/Login')),
    },
    register: {
      path: '/auth/register',
      exact: true,
      component: lazyLoad(() => import('views/Auth/Signup')),
    },
    autoLogin: {
      path: '/auth/autologin',
      exact: true,
      component: lazyLoad(() => import('views/Auth/AutoLogin')),
    },
    changeEmailConfirm: {
      path: '/auth/change-email-confirm',
      exact: true,
      component: lazyLoad(() => import('views/Auth/ChangeEmailConfirm')),
    },
  },
} as const
